function AboutTitle() {
    return (
        <div>
            <h1 className="hero-text">A Little Bit About Me &</h1>
            <h1 className="hero-text">This Website</h1>
        </div>
    )
}

export default AboutTitle;